import { Component, input } from '@angular/core';

@Component({
    selector: 'app-telemetry-status-circle',
    imports: [],
    templateUrl: './telemetry-status-circle.component.html',
    styleUrl: './telemetry-status-circle.component.scss'
})
export class TelemetryStatusCircleComponent {
    status = input.required<'online' | 'offline' | 'warning' | 'error'>();
}
